import { TheNav, Fotter } from './Home'
import FormationMenu from './FormationMenu'
import SSTpic from '../Assets/SST.png'
import SSTinPdf from '../Assets/SSTinPdf.pdf'
import { Timer } from "lucide-react";
import { ChevronRightIcon } from '@heroicons/react/24/outline';

const sections = [
    { title: "Description de la formation", content: "✓ La formation SST (Sauveteur Secouriste du Travail) prépare les employés à prévenir les risques professionnels et à intervenir efficacement en cas d'accident sur le lieu de travail, en prodiguant les premiers secours." },
    { title: "PreRequis", content: "✓ Aucun prérequis." },
    { title: "Objectifs", content: "✓ Acquérir des compétences sur les gestes de premier secours et la prévention au travail." },
    { title: "Contenu", content: "9 principes généraux de prévention pour guider à chaque instant les actions de celles et de ceux qui s’impliquent dans la lutte contre les risques professionnels. \n 1. Eviter les risques \n 2. Evaluer les risques qui ne peuvent pas être évités \n 3. Combattre les risques à la source \n 4. Adapter le travail à l’homme \n 5. Tenir compte de l’évolution de la technique \n 6. Remplacer ce qui est dangereux par ce qui ne l’est pas ou par ce qui l’est moins \n 7. Planifier la prévention \n 8. Donner la priorité aux mesures de protection collective \n 9. Former et informer les salariés sur les risques et leur prévention"},
    { title: "Taux de réussite et d'abandon", content: "✓ 100% réussite \n ✓ 0% d'abandon"},
    { title: "Méthodes mobilisées", content: "✓ Mannequins adulte, junior, bébé. Masques individuels, protection individuelle, \n ✓ Plan SST de l’INRS avec jeu de carte magnétiques, \n ✓ Tête articulée, défibrillateur et matériel nécessaire à la mise en place des situations pratiques" },
    { title: "Modalités d’accès formation", content: "Sous réserve d’avoir les prérequis et en fonction du nombre de candidats." },
    { title: "Modalités d’accès au centre", content: "Accessible par les transports en commun, à 10 min de la station de RER la plus proche à Noisy-le-Grand. En voiture, un parking public est disponible à proximité. Accessible aux personnes en situation de handicap. Contacter le référent handicap pour une réception personnalisée." },
    { title: "Contact", content: "La Francilienne de la Formation Noisy le Grand: \n - Téléphone : 09 52 30 99 38 \n - Email : Direction.francilienne.formation@gmail.com \n La Francilienne de la Formation Rennes: \n - Téléphone : 06 48 75 95 18 \n - Email : lffrennes@gmail.com" },
];


const data = [
    {
      objective: "1ère demi-journée (09h00 - 12h00)",
      knowledge: [
        "Présentation de la formation et de son organisation",
        "Le Sauveteur Secouriste du travail",
        "Les notions de base en prévention des risques professionnels",
        "10h00 : Pause d’un 1/4 d’heure",
        "La prévention des risques professionnels dans l’entreprise/établissement",
        "12h00 - 13h00 : Pause déjeuner",
      ],
      duration: "3h",
    },
    {
      objective: "2ème demi-journée (13h00 - 17h00)",
      knowledge: [
        "Les actions « protéger, examiner, faire alerter/alerter, secourir »",
        "15h00 : Pause d’un 1/4 d’heure",
      ],
      duration: "4h",
    },
    {
      objective: "3ème demi-journée (09h00 - 12h00)",
      knowledge: [
        "Les actions « secourir suite »",
        "10h00 : Pause d’un 1/4 d’heure",
      ],
      duration: "3h",
    },
    {
      objective: "4ème demi-journée (13h00 - 17h00)",
      knowledge: [
        "Les actions « secourir suite et fin »",
        "15h00 : Pause d’un 1/4 d’heure",
        "Épreuves certificatives",
        "Bilan de la formation",
      ],
      duration: "4h",
    },
  ];  

export const Details = () =>{
    return(
        <div className='h-fit undi:pt-[14vh] pt-[22vh] md:pb-[8vh] pb-[3vh] md:px-[100px] px-[40px] flex flex-col justify-between items-center'>
            <div className='w-full flex justify-center items-center'>
                <img src={SSTpic} alt="SSIAP LOGO" className='h-24 w-24 mr-4'/>
                <h3 className='font-bold text-4xl text-center font-times'>Formation SST Initial</h3>
            </div>
            <div className='w-full'>
                <FormationMenu sections={sections} />
            </div>
            <div className='w-[90vw] mx-0 h-fit undi:w-[75vw]'>
                <table className="w-full border border-gray-300 text-left">
                    <thead>
                    <tr className="bg-gray-200 text-red-600">
                        <th className="border border-gray-300 px-4 py-2" colSpan={3}>Programme de la Formation initiale SST (2 jours)</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.map((row, index) => (
                        <tr key={index} className="border border-gray-300">
                        <td className="border border-gray-300 px-4 py-2 font-bold">
                            {row.objective}
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                            <ul className="list-disc pl-4">
                            {row.knowledge.map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                            </ul>
                        </td>
                        <td className="border border-gray-300 px-4 py-2 font-bold text-red-600">
                            {row.duration}
                        </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <a href={SSTinPdf} className='mb-10 mt-6 text-lg font-semibold text-[#D72427] text-center w-full'>Télécharger le tableaux ici !</a>

            <div className='w-[100vw] bg-[#D72427] h-fit flex justify-center items-center mt-7 mb-4'>
                <p className='text-xl font-semibold text-white text-center w-full my-7 uppercase'>Certification délivrée par l’INRS</p>
            </div>  

            <div className='h-fit w-full pt-[5vh] md:pb-[8vh] flex flex-col justify-between items-center'>
                <div className='h-5/6 w-full flex justify-evenly items-center flex-wrap'>
                    <div className='h-[11rem] md:w-[22rem] w-5/6 bg-[#F5F5F7] rounded-2xl px-4 py-6 flex flex-col justify-around items-center my-2'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-16 w-16">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
                        </svg>
                        <div className='flex flex-col items-center justify-center'>
                            <h5 className='text-xl text-center font-bold'>Effectif</h5>
                            <p className='text-center text-lg '>4 à 10 personnes maximum</p>
                        </div>
                    </div>
                    <div className='h-[11rem] md:w-[22rem] w-5/6 bg-[#F5F5F7] rounded-2xl px-4 py-6 flex flex-col justify-around items-center my-2'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-16 w-16">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                        <div className='flex flex-col items-center justify-center'>
                            <h5 className='text-xl text-center font-bold'>Délais d'accès</h5>
                            <p className='text-center text-lg '> 2 à 4 semaines.</p>
                        </div>
                    </div>
                    <div className='h-[11rem] md:w-[22rem] w-5/6 bg-[#F5F5F7] rounded-2xl px-4 py-6 flex flex-col justify-around items-center my-2'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-16 w-16">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z" />
                        </svg>
                        <div className='flex flex-col items-center justify-center'>
                            <h5 className='text-xl text-center font-bold'>Méthodes D’évalution</h5>
                            <p className='text-center text-lg '>Test Sauveteur Secouriste (UV.1)</p>
                        </div>
                    </div>
                    <div className='h-[11rem] md:w-[22rem] w-5/6 bg-[#F5F5F7] rounded-2xl px-4 py-6 flex flex-col justify-around items-center my-2'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-16 w-16">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M14.25 7.756a4.5 4.5 0 1 0 0 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                        <div className='flex flex-col items-center justify-center'>
                            <h5 className='text-xl text-center font-bold'>Tarifs</h5>
                            <p className='text-center text-lg '>Devis personnalisé par le financement.</p>
                        </div>
                    </div>
                    <div className='h-[11rem] md:w-[22rem] w-5/6 bg-[#F5F5F7] rounded-2xl px-4 py-6 flex flex-col justify-around items-center my-2'>
                        <Timer className="h-16 w-16 font-medium text-black-500" />
                        <div className='flex flex-col items-center justify-center'>
                            <h5 className='text-xl text-center font-bold'>Durée</h5>
                            <p className='text-center text-lg '>14 heures</p>
                        </div>
                    </div>
                    <a href="/Contact" className='h-[11rem] md:w-[22rem] w-5/6 bg-[#F5F5F7] rounded-2xl px-4 py-6 flex flex-col justify-around items-center cursor-pointer hover:bg-opacity-50'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-16 w-16">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
                        </svg>
                        <div className='flex flex-col items-center justify-center '>
                            <h5 className='text-xl text-center font-bold'>Dates</h5>
                            <p className='text-center text-lg  flex items-end underline'>Nous contacter pour les dates <ChevronRightIcon className="h-5 w-5 text-black stroke-[2px] mb-0.5" /></p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
}

export const SSTin = () =>{
    return(
        <>
            <TheNav/>
            <Details/>
            <Fotter/>
        </>
    );
}